import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import EquipmentGroupsApi from '@/services/apiServiceModules/equipmentGroupsApi.js'
const equipmentGroupsApi = new EquipmentGroupsApi()

export default class EquipmentGroupsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.EQUIPMENT_GROUPS, equipmentGroupsApi, {
			useCache: true,
		})
	}
}
